/**
 * Partner page scrollspy + in-page nav (Mia / store-mia behaviour).
 * Expects a root with [data-bh-partner-nav], [data-bh-partner-topbar], optional data-bh-partner-last.
 */
(function (global) {
  function initPartnerNav(pageRoot) {
    if (!pageRoot || pageRoot.getAttribute('data-bh-partner-nav-ready') === '1') return;
    var nav = pageRoot.querySelector('[data-bh-partner-nav]');
    if (!nav) return;

    function getScrollOffset() {
      var topbar = pageRoot.querySelector('[data-bh-partner-topbar]');
      var topbarH = topbar ? topbar.getBoundingClientRect().height : 0;
      return Math.round(topbarH + 12);
    }

    function applyScrollPadding() {
      var offset = getScrollOffset() + 'px';
      document.documentElement.style.scrollPaddingTop = offset;
    }
    applyScrollPadding();

    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    var byId = {};
    var sectionIds = [];
    links.forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.length < 2) return;
      var id = href.slice(1);
      if (!id || byId[id]) return;
      if (!document.getElementById(id)) return;
      byId[id] = a;
      sectionIds.push(id);
    });
    if (!sectionIds.length) return;

    var lastId = pageRoot.getAttribute('data-bh-partner-last') || sectionIds[sectionIds.length - 1];
    var rail = pageRoot.querySelector('.bh-mia-topnav-rail');

    function scrollActiveLinkIntoView(link) {
      if (!rail || !link) return;
      var linkLeft = link.offsetLeft;
      var linkWidth = link.offsetWidth;
      var railWidth = rail.clientWidth;
      var target = linkLeft - railWidth / 2 + linkWidth / 2;
      rail.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    function setActive(id) {
      links.forEach(function (a) {
        a.classList.remove('is-active');
        a.removeAttribute('aria-current');
      });
      var link = byId[id];
      if (link) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'true');
        scrollActiveLinkIntoView(link);
      }
    }

    function computeActive() {
      var line = window.innerHeight * 0.3;
      var active = sectionIds[0];
      sectionIds.forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        if (el.getBoundingClientRect().top <= line) active = id;
      });
      var doc = document.documentElement;
      if (window.scrollY + window.innerHeight >= doc.scrollHeight - 8) active = lastId;
      setActive(active);
    }

    var scrollTimer;
    function onScroll() {
      if (scrollTimer) cancelAnimationFrame(scrollTimer);
      scrollTimer = requestAnimationFrame(computeActive);
    }

    function prefersReducedMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    function scrollToSection(id, updateHash) {
      var el = document.getElementById(id);
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.scrollY - getScrollOffset();
      if (top < 0) top = 0;
      window.scrollTo({ top: top, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      if (updateHash !== false) {
        try {
          history.pushState(null, '', '#' + id);
        } catch (e) {
          location.hash = id;
        }
      }
      setActive(id);
    }

    nav.addEventListener('click', function (e) {
      var t = e.target.closest('a[href^="#"]');
      if (!t || !nav.contains(t)) return;
      var id = t.getAttribute('href').slice(1);
      if (!id || !byId[id]) return;
      e.preventDefault();
      scrollToSection(id, true);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      applyScrollPadding();
      onScroll();
    }, { passive: true });

    window.addEventListener('hashchange', function () {
      var h = (location.hash || '').replace(/^#/, '');
      if (h && byId[h]) setActive(h);
    });

    if (location.hash) {
      var hid = location.hash.replace(/^#/, '');
      if (byId[hid]) {
        requestAnimationFrame(function () {
          scrollToSection(hid, false);
        });
      } else {
        computeActive();
      }
    } else {
      computeActive();
    }

    pageRoot.setAttribute('data-bh-partner-nav-ready', '1');
  }

  global.BeeHivePartnerNav = { init: initPartnerNav };
})(typeof window !== 'undefined' ? window : this);
